module.exports = function() {
  return new Worker(__webpack_public_path__ + "e5c7cab0092eeae31098.worker.js");
};